/*
  ConfirmationModal
  A simple, styled version of the BaseModal that provides a customizable Yes/No prompt
*/

import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

import BaseModal from './BaseModal';
import { Theme } from '../theme';

const Modal = styled(BaseModal)`
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : '700px')};
`;

const defaultColor = (color) =>
  color || Theme.colors.linksDesignElementsBaseColor;

export const MainButton = styled('button')`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${defaultColor((props) => props.brandColor)};
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 25px;
  padding-left: 25px;
  font-weight: 400;
  border-radius: 4px;
  color: white;
  font-size: 14px;

  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  opacity: ${(props) => (props.disabled ? '0.3' : '1')};

  i {
    font-size: 14px;
    line-height: 14px;
    margin-right: 10px;
    font-weight: 600;
  }

  border: none;
`;

// Modal Styles + Action Buttons =====
export const ModalBody = styled('div')`
  text-align: left;
  padding: 30px;
`;

export const Title = styled('div')`
  font-size: 22px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 20px;
  color: ${Theme.colors.primaryTextColor};
`;

export const Message = styled('p')`
  font-size: 16px;
  color: ${Theme.colors.primaryTextColor};
`;

export const Actions = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
`;

export const buttonCss = css`
  font-size: 16px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 18px;
  padding-right: 18px;
`;

export const CancelButton = styled(MainButton)`
  ${buttonCss};
  color: ${Theme.colors.secondaryTextColor};
  border: 1px solid ${Theme.colors.line};
  background-color: white;
`;

export const ConfirmButton = styled(MainButton)`
  ${buttonCss};
  border: 1px solid ${defaultColor((props) => props.brandColor)};
`;
// ===== Modal Action Buttons

export const ConfirmationModal = ({
  className,
  children,
  cancelDisabled,
  confirmDisabled,
  title,
  messages,
  cancelLabel,
  confirmLabel,
  hideClose,
  open,
  close,
  onCancel,
  onConfirm,
  brandColor,
}) => (
  <Modal open={open} close={close} hideClose={hideClose} className={className}>
    <ModalBody>
      <Title>{title}</Title>
      {messages.map((message) => (
        <Message key={message}>{message}</Message>
      ))}
      {children}
      <Actions>
        <CancelButton disabled={cancelDisabled} onClick={onCancel}>
          {cancelLabel}
        </CancelButton>
        <ConfirmButton
          disabled={confirmDisabled}
          brandColor={brandColor}
          onClick={onConfirm}
          data-testid="modal-confirm-button"
        >
          {confirmLabel}
        </ConfirmButton>
      </Actions>
    </ModalBody>
  </Modal>
);

ConfirmationModal.defaultProps = {
  className: '',
  children: null,
  cancelDisabled: false,
  confirmDisabled: false,
  title: 'Title',
  messages: ['Message 1', 'Message 2'],
  cancelLabel: 'Cancel',
  confirmLabel: 'Confirm',
  brandColor: Theme.colors.linksDesignElementsBaseColor,
  open: false,
  hideClose: false,
  close: () => console.log('Provide a close function prop'),
  onCancel: () => console.log('Provide a onCancel function prop'),
  onConfirm: () => console.log('Provide a onConfirm function prop'),
};
